import request from '@/config/axios'

/** 字段包导入合并结果（预览，不落库） */
export interface CatalogFieldPackImportVO {
  fieldsConfig?: string
  specialRules?: string
  certRequirements?: string
  flowModel?: string
  payType?: string
  priceType?: string
  categoryCode?: string
  packCode?: string
}

export const CatalogFieldPackApi = {
  getList: async () => {
    return await request.get({ url: '/o2o/catalog/field-pack/list' })
  },
  importPack: async (data: { categoryId: number; packCode: string }) => {
    return await request.post({ url: '/o2o/catalog/field-pack/import', data })
  },
  /** 将字段包玩法写入服务（不改品类认证） */
  applyToService: async (data: { serviceId: number; packCode: string }) => {
    return await request.post({ url: '/o2o/catalog/field-pack/apply-to-service', data })
  }
}
